import {inject, Pipe, PipeTransform} from '@angular/core';
import {I18NService} from './i18n.service';
import {StringUtils} from "./string.utils";


@Pipe({name: 'i18n'})
export class I18nPipe implements PipeTransform {

    i18n: I18NService = inject(I18NService);

    transform(aMessageId: string, aMessageParams: any[]): string {
        if (!aMessageId) {
            return null;
        }
        let pMessage = this.i18n.v(aMessageId);
        return aMessageParams?.length ? StringUtils.format(pMessage, aMessageParams) : pMessage;
    }
}
